import { GoalPeriod, TaskListType } from '@akin-home/amplify';
import { z } from 'zod';

export const CreateGoalCommand = z.object({
  type: z.literal('create_goal'),

  data: z.object({
    title: z.string(),
    emoji: z.string().optional(),
    period: z.nativeEnum(GoalPeriod).optional(),
    completions_per_period: z.coerce.number().optional(),

    success_message: z.string().optional(),
    error_message: z.string().optional(),
  }),
});

export const CreateChecklistCommand = z.object({
  type: z.literal('create_checklist'),

  data: z.object({
    title: z.string(),
    emoji: z.string().optional(),
    type: z.nativeEnum(TaskListType).optional(),

    success_message: z.string().optional(),
    error_message: z.string().optional(),
  }),
});

export const RefetchStateVariablesCommand = z.object({
  type: z.literal('refetch_state_variables'),
});

export type RefetchStateVariablesCommand = z.infer<
  typeof RefetchStateVariablesCommand
>;
